module.exports = __webpack_public_path__ + "img/exit.ec77e816.svg";